import { IconButton, Tooltip } from '@mui/material';
import { MenuOpen, Menu } from '@mui/icons-material';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useMenuToggleButtonStyles from './styles';
import { MenuToggleButtonProps } from './types';

const MenuToggleButton: React.FunctionComponent<MenuToggleButtonProps> = (props) => {
  const { open, onClick, hasSameOpenCloseMenuIcons = true, ...buttonProps } = props;
  const { t } = useTranslation('common');
  const classes = useMenuToggleButtonStyles();

  const renderButton = useMemo(
    () => (
      <IconButton
        {...buttonProps}
        className={clsx(classes.menuToggle, { [classes.menuToggleClosed]: !open })}
        onClick={onClick}
        size="large">
        {hasSameOpenCloseMenuIcons || open ? <MenuOpen /> : <Menu />}
      </IconButton>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [buttonProps, open, onClick]
  );

  const renderMenuIcon = () => {
    return <Tooltip title={t(open ? 'hideMenu' : 'showMenu')}>{renderButton}</Tooltip>;
  };

  return renderMenuIcon();
};

export default MenuToggleButton;
